import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../../../../emotion-theme";

export const HostContainer = styled.div`
  display: block;
  padding: 10px 16px;
  width: 100%;
  border-bottom: solid 1px ${BASE_COLORS.lightGrey};
`;
export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`;
export const FlexItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
